import { KYMW7201Model } from '../kymw7201.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { Router } from '@angular/router';
import { KYMW00Model } from '../../../../commons/kymw00/kymw00.model';

/**
 * 運営商品情報を登録する
 *
 * @export RegistOperationGoodsService
 * @class RegistOperationGoodsService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class RegistOperationGoodsService extends PlessJsonResponderSub<any> {

  private model: KYMW7201Model;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub,
    private router: Router,
    private kymw00Model: KYMW00Model,

  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateIndividuallyOrderNumService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      regist: {
        RegistOperationGoods: {
          parameter: {
            OperationGoodsStatus: this.model.operationGoodsStatus,
            DeliveryDiv: this.model.deliveryDiv,
            OrderNum: this.model.orderNum,
            PlanningManagementDiv: this.model.planningManagementDiv,
            PlanningManagementDetailDiv: this.model.planningManagementDetailDiv,
            OrderReceptionStartCatalog: this.model.orderReceptionStartCatalog,
            OrderReceptionEndCatalog: this.model.orderReceptionEndCatalog,
            DepositCapitalIncreasePattern: this.model.depositCapitalIncreasePattern,
            DepositCapitalIncreaseCount: this.model.depositCapitalIncreaseCount,
            UnitPrice: this.model.unitPrice,
            FormFlyerCode: this.model.formFlyerCode,
            PointNumber: this.model.pointNumber,
            PauseGroupCode: this.model.pauseGroupCode,
            PdDiv: this.model.pdDiv,
            DeliveryLeadDiv: this.model.deliveryLeadDiv,
            GoodsName: this.kymw00Model.deleteStartAndEndSpace(this.model.goodsName),
            GoodsNameKana: this.kymw00Model.deleteStartAndEndSpace(this.model.goodsNameKana),
            StandardName: this.kymw00Model.deleteStartAndEndSpace(this.model.standardName),
            StandardNameKana: this.kymw00Model.deleteStartAndEndSpace(this.model.standardNameKana),
            AppropriatingClass: this.model.appropriatingClass,
            ConsumeTaxDiv: this.model.consumeTaxDiv,
            ConsumeTaxRate: this.model.consumeTaxRate,
          },
          combination: this.model.coopCodeList.map(coopCode => {
            return {
              parameter: {
                CoopCode: coopCode
              }
            }
          })
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof RegistOperationGoodsService
   */
  execute(model: KYMW7201Model, successFunc: Function = null): void {
    this.model = model;
    this.successFunc = successFunc;
    this.send('registOperationGoods', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof RegistOperationGoodsService
   */
  success(data: any): void {
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }

  /**
   * API通信失敗時の処理
   *
   * @param {*} errList レスポンスデータ
   * @memberof UpdateOperationGoodsService
   */
  public plessErrorHandler(errList: Object): void {
    super.plessErrorHandler(errList);
    this.router.navigate(['/kymw/7200'], {
    });
  }

  /**
   * システムエラー時のメソッド
   * @param errList サーバ受信データ
   *  機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
    this.router.navigate(['/kymw/7200'], {
    });
  }
}
